import { render, staticRenderFns } from "./QuestIdentity.vue?vue&type=template&id=e478f322&scoped=true&"
import script from "./QuestIdentity.ts?vue&type=script&lang=ts&"
export * from "./QuestIdentity.ts?vue&type=script&lang=ts&"
import style0 from "./QuestIdentity.scss?vue&type=style&index=0&id=e478f322&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e478f322",
  null
  
)

export default component.exports